import React from "react";
import { TabData } from "../useSearch";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import styles from "./SearchTab.module.scss";
import { SearchTabContent } from "./SearchTabContent/SearchTabContent";
interface SearchTabProps {
  currentTab: number;
  setCurrentTab: (index: number) => void;
  tabsData: Record<number, TabData>;
  fetchMore: () => void;
}

export const SearchTab = ({
  setCurrentTab,
  currentTab,
  tabsData,
  fetchMore,
}: SearchTabProps) => {
  const { getLabel } = useGlobalContext();
  const searchLabels = getLabel(
    "search_tab_titles",
    "Alle,Rezepte,Zutaten,Weiteres",
  )
    .split(",")
    .map((label) => label.trim());
  return (
    <div className="column is-10-tablet is-8-widescreen">
      <ul
        role="tablist"
        aria-label="search tabs"
        className={`${styles["tabs-wrapper"]} is-flex`}
      >
        {searchLabels.map((tabTitle, i) => (
          <Tab
            key={i}
            index={i}
            tabHeadline={`${tabTitle}`}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
        ))}
      </ul>
      <SearchTabContent
        fetchMore={fetchMore}
        labelledby={searchLabels[currentTab]}
        tabData={tabsData[currentTab]}
        currentTab={currentTab}
      />
    </div>
  );
};

interface TabProps {
  tabHeadline: string;
  index: number;
  currentTab: number;
  setCurrentTab: (index: number) => void;
}

export const Tab: React.FC<TabProps> = ({
  tabHeadline,
  index,
  currentTab,
  setCurrentTab,
}) => {
  const isActive = currentTab === index;

  return (
    <li role="presentation">
      <button
        id={`tab-${tabHeadline.toLowerCase().replace(/\s+/g, "-")}`}
        role="tab"
        aria-selected={isActive}
        className={`${styles["tab-button"]} has-text-centered  button-reset`}
        data-is-active={isActive}
        onClick={() => setCurrentTab(index)}
      >
        {tabHeadline}
      </button>
    </li>
  );
};
